import { RouteRecordRaw } from 'vue-router';

import { ROUTE_NAMES } from '@/constants';
import i18n, { loadTranslations } from '@/plugins/i18n';

const ShipAssistView = () => import('@/pages/ShipAssist/index.vue');
const PackOrderView = () => import('@/pages/ShipAssist/PackOrder/PackOrder.vue');
const TotesListView = () => import('@/pages/ShipAssist/Totes/Totes.vue');
const EditOrderView = () => import('@/pages/ShipAssist/EditOrder/EditOrder.vue');

async function beforeEnter() {
  await loadTranslations('shipAssist');
}

const shipAssistRoutes: RouteRecordRaw[] = [
  {
    path: 'ship-assist/',
    meta: {
      title: i18n.t('shipAssist.title'),
      permissions: [
        {
          rules: [
            'enablePackingApp',
            'enableShipAssist',
            'canAccessPackingApp',
            ({ userActiveCompany }) => Boolean(userActiveCompany?.staffId),
          ],
        },
      ],
    },
    beforeEnter,
    component: ShipAssistView,
    children: [
      {
        path: '',
        name: ROUTE_NAMES.SHIP_ASSIST,
        redirect: (to) => ({ name: ROUTE_NAMES.PACK_ORDER, params: { company: to.params.company } }),
      },
      {
        path: 'start/:sellerId?',
        name: ROUTE_NAMES.PACK_ORDER,
        component: PackOrderView,
      },
      {
        path: 'totes/:sellerId?',
        name: ROUTE_NAMES.TOTES,
        component: TotesListView,
      },
      {
        path: ':sellerId?/:packingOrder/edit',
        name: ROUTE_NAMES.EDIT_PACKING_ORDER,
        component: EditOrderView,
      },
      {
        // TODO: change it with the correct routing
        path: ':catchAll(.*)*',
        name: ROUTE_NAMES.SHIP_ASSIST_WILDCARD,
        redirect: { name: ROUTE_NAMES.ERROR_404 },
      },
    ],
  },
];

export default shipAssistRoutes;
